import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import '../css/footer.scss'
import { StaticImage } from 'gatsby-plugin-image'

function Footer() {
  const data = useStaticQuery(graphql`
    {
      s1: file(relativePath: { eq: "landing/s1.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
        }
      }

      s2: file(relativePath: { eq: "landing/s2.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
        }
      }

      s3: file(relativePath: { eq: "landing/s3.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
        }
      }

      s4: file(relativePath: { eq: "landing/s4.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
        }
      }

      s5: file(relativePath: { eq: "landing/s5.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, layout: FULL_WIDTH)
        }
      }
    }
  `)

  return (
    <section className="footer-sec">
      <div className="container">
        <ul>
          <li>
            <label>ABOUT US</label>
            <Link to="/about-us?tab=1">{'> '} Our Team</Link>
            <Link to="/blogs">{'> '} Blogs</Link>
            <Link to="/doctor-speak">{'> '} Doctor Speak</Link>
            <Link to="/press-media/">{'> '} Press & Media</Link>
            <Link to="/investor-relations/">{'> '} Investor Relations</Link>
            <Link to="/annual-return/">{'> '} Annual Return</Link>
            <Link to="/careers/">{'> '} Careers</Link>
            <Link to="/partner-with-us/">{'> '} Partner With Us</Link>
            <Link to="/contact-us/">{'> '} Contact Us</Link>
            <a href="https://one.portea.com/client/faqs/">{'> '} FAQs</a>
            <Link to="/testimonials/Physiotherapy">{'> '} Testimonials</Link>
          </li>
          <li>
            <label>OUR SERVICES</label>
            <Link to="/physiotherapy/">{'> '} Physiotherapy</Link>
            <Link to="/doctor-consultations/">{'> '} Doctor Consultations</Link>
            <Link to="/nursing/">{'> '} Nursing</Link>
            <Link to="/medical-equipment">{'> '} Medical Equipment</Link>
            <Link to="/trained-attendants/">{'> '} Trained Attendants</Link>
            <Link to="/diagnostic/">{'> '} Lab Tests</Link>
            <Link to="/counselling/">{'> '} Counselling</Link>
          </li>
          <li>
            <label>POPULAR SERVICES</label>
            <Link to="/physiotherapy/back-pain/">
              {'> '} Physiotherapy for Back Pain
            </Link>
            <Link to="/physiotherapy/sports-injury-treatment/">
              {'> '} Physiotherapy for sports
            </Link>
            <Link to="/elder-care/">{'> '} Eldercare for Parents</Link>
            <Link to="/nursing/injection">{'> '} Injections and IVs</Link>
            <Link to="/diagnostic/">{'> '} Cholesterol tests</Link>
            <a href="https://www.portea.com/referral/">{'> '} Refer a friend</a>
          </li>
          <li>
            <label>CONTACT US</label>
            <div>
              <h5>For Bookings and Service queries:</h5>
              <span>Ph: 1800 121 2323</span>
              <span> Email: bookings@portea.com</span>
            </div>
            <div>
              <h5>For Customer Support & Feedback:</h5>
              <span>Ph: 1800 121 2323 </span>
              <span> Email:customersupport@portea.com</span>
            </div>
            <div className="social-icon">
              <a href="https://www.facebook.com/pages/Portea-Medical/661365503891890">
                <StaticImage
                  src="../img/landing/s1.png"
                  alt="Facebook"
                  layout="fixed"
                  width={44}
                  height={44}
                  loading="lazy"
                />
              </a>
              <a href="https://twitter.com/PorteaMedical">
                <StaticImage
                  src="../img/landing/s2.png"
                  alt="Twitter"
                  layout="fixed"
                  width={44}
                  height={44}
                  loading="lazy"
                />
              </a>
              <a href="https://www.youtube.com/channel/UCQNcs-ffxMuMBjN_RDYXLdA">
                <StaticImage
                  src="../img/landing/s3.png"
                  alt="Youtube"
                  layout="fixed"
                  width={44}
                  height={44}
                  loading="lazy"
                />
              </a>
              <a href="https://instagram.com/portea.medical?utm_medium=copy_link">
                <StaticImage
                  src="../img/landing/s4.png"
                  alt="Instagram"
                  layout="fixed"
                  width={44}
                  height={44}
                  loading="lazy"
                />
              </a>
              <a href="https://www.linkedin.com/company/portea-medical/">
                <StaticImage
                  src="../img/landing/s5.png"
                  alt="LinkedIn"
                  layout="fixed"
                  width={44}
                  height={44}
                  loading="lazy"
                />
              </a>
            </div>
          </li>
        </ul>
        <p>
          *I agree to be contacted by Portea over phone and email. I do not have
          any objection to receiving emails, messages (SMS or any other mode)
          and calls from Portea. This consent shall supersede any preferences
          set through Do Not Disturb (DND Register)/ National Customer
          Preference Register (NCPR).
          <br />

        </p>
        <div className="copyright">
          <div className="copyright-row">
            <span>
              <Link to="/privacy-policy/">Privacy Policy | </Link>
              <Link to="/terms-conditions/">Terms and Conditions | </Link>
              <Link to="/patient-rights-and-responsibilities/">
                Patient Rights & Responsibilities
              </Link>
            </span>
            <span>
              © {new Date().getFullYear()} Healthvista India Private Limited.
              All rights reserved.
            </span>
          </div>
          <p className="legal-entity">
            Portea™ is a brand of Healthvista India Private Limited
            &nbsp;·&nbsp; CIN: U85300KA2013PTC069291
          </p>
        </div>
      </div>
    </section>
  )
}

export default Footer
